import { MENU } from 'menus/constants/entities';

export const MENU_BASE = `/:slug/menu`;
export const MENU_ORDER_SETTING = `${MENU_BASE}/order-settings`;
export const MENU_ITEM_DETAIL = `${MENU_BASE}/:menuItemSlug`;

export const entityPathMap = {
  [MENU]: {
    menu: MENU_BASE,
    orderSetting: MENU_ORDER_SETTING,
    menuItemDetail: MENU_ITEM_DETAIL
  }
};
